import { Icon } from '@foam/buoy/src/components/Icon/Icon';
import { IconButton } from '@foam/buoy/src/components/IconButton/IconButton';
import { Input } from '@foam/buoy/src/components/Input/Input';
import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { useDebounce } from '~/hooks/api/useDebounce';

interface SearchInputProps {
  onSearch: (query: string) => void;
  placeholder?: string;
  debounceMs?: number;
}

export const SearchInput = ({
  onSearch,
  placeholder = 'Search by keywords',
  debounceMs = 300,
}: SearchInputProps) => {
  const [inputValue, setInputValue] = useState('');
  const debouncedValue = useDebounce(inputValue, debounceMs);

  useEffect(() => {
    onSearch(debouncedValue ?? '');
  }, [debouncedValue, onSearch]);

  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  }, []);

  const handleReset = useCallback(() => {
    setInputValue('');
  }, []);

  return (
    <div className="relative">
      <Input
        id="searchContentId"
        name="searchContent"
        value={inputValue}
        onChange={handleChange}
        placeholder={placeholder}
        className="h-10 w-full px-3 text-16 leading-24"
        aria-label={placeholder}
      />
      <div className="absolute right-3 top-1/2 flex -translate-y-1/2 items-center justify-center">
        {inputValue.length > 0 ? (
          <IconButton
            aria-label="Clear search"
            icon="Close"
            onClick={handleReset}
            variant="ghost"
            size="sm"
          />
        ) : (
          <Icon name="Search" color="neutral.300" />
        )}
      </div>
    </div>
  );
};
